// mport { ConfigMurucaResourceLayout } from '@net7/boilerplate-muruca';

export default {
  maxHeight: 100, // Threshold where the "read-more" button appears
  title: 'Viaggio',
  type: 'voyage',
  sections: {
    top: [
      {
        id: 'header',
        type: 'title',
      },
    ],
    content: [
      {
        id: 'metadata',
        type: 'metadata',
      },
    ],
  },
};
